export const loanCalculatorData = [
  {
    id: 1,
    heading:
      "ICICI Car Loan EMI Calculator: Plan Your Car Loan Repayments with Ease",
    subHeading:
      "Use the ICICI Car Loan EMI Calculator to estimate your monthly installments and plan your car loan repayments more effectively. Whether you’re purchasing a new car or used car, this tool offers a quick, accurate, and easy way to calculate your monthly EMIs, total repayment amount, and interest details. Take charge of your finances and make informed decisions with ICICI Bank's EMI calculator.",

    notice:
      "The calculations provided are for illustrative purposes only. Actual loan terms may vary based on the lender’s policies and your credit profile.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
